<div class="spinner">
  <div class="bounce1" [ngClass]="bgColor"></div>
  <div class="bounce2" [ngClass]="bgColor"></div>
  <div class="bounce3" [ngClass]="bgColor"></div>
</div>